// @ts-nocheck
import React, { Component } from 'react';
import { observer, inject } from "../../../../stores/mobx-compat";

import Button from '../../../ui/Button';
import CapturePlans from '../CapturePlans';

class CapturePlansUpgrade extends Component {
  render() {
    const { selectedPlan } = this.props.store.payments;
    const { planObj } = this.props.store.accountStatus;
    return (
      <>
        <CapturePlans />
        <div className="mt-5 flex justify-end">
          <Button
            variant="primary"
            disabled={planObj.id === selectedPlan[0]}
            onClick={() => this.props.store.payments.upgradePlan()}
          >
            Update plan
          </Button>
        </div>
      </>
    );
  }
}

export default inject('store')(observer(CapturePlansUpgrade));
